export default __webpack_public_path__ + "static/media/icon-plus-button.28afc7d2.svg";